// Custom event to trigger auth refetch from anywhere
const AUTH_REFETCH_EVENT = 'auth:refetch';
const AUTH_LOGOUT_EVENT = 'auth:logout';

/**
 * Trigger AuthProvider to refetch authentication state
 * Can be called from anywhere in the app
 */
export function triggerAuthRefetch() {
  window.dispatchEvent(new Event(AUTH_REFETCH_EVENT));
}

/**
 * Trigger AuthProvider to handle logout
 * Immediately sets isAuthenticated to false and refetches
 */
export function triggerAuthLogout() {
  window.dispatchEvent(new Event(AUTH_LOGOUT_EVENT));
}

// Export event names for AuthProvider to use
export const AUTH_EVENTS = {
  REFETCH: AUTH_REFETCH_EVENT,
  LOGOUT: AUTH_LOGOUT_EVENT,
} as const;

